import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "side-menu" }
const _hoisted_2 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_SideMenuTitle = _resolveComponent("SideMenuTitle")
  const _component_SideMenuItem = _resolveComponent("SideMenuItem")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuCategories, (category, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_SideMenuTitle, {
          title: category.title,
          to: category.to
        }, null, 8, ["title", "to"]),
        (category.items)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items.filter((i) =>
                    _ctx.isMenuItemVisible(
                        i.allowedRoles,
                        i.allowedRoleTypes,
                        i.claims
                    )
                ), (item, index) => {
                return (_openBlock(), _createBlock(_component_SideMenuItem, {
                  key: index,
                  item: item
                }, null, 8, ["item"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}